<template>
  <div>

              <CRow class="m-1">
                <CCol col="3">
                  <date-picker
                      :label="$t('components.startDate')"
                      v-model="start_date"></date-picker>
                </CCol>
                <CCol col="3">
                  <date-picker
                      :label="$t('components.endDate')"
                      v-model="end_date"></date-picker>

                </CCol>

                <CCol col="2">
                  <CButton size="sm" @click="get_all_data()" color="secondary">
                    {{ $t('search') }}
                  </CButton>
                </CCol>
                <CCol col="2">
                  <CButton @click="change_factor_status_modal=true"
                           type="submit" size="sm" color="secondary">
                    {{ $t('acceptExitProducts') }}
                  </CButton>
                </CCol>
              </CRow>


              <CDataTableFixed
                  :items="exit_factor_inventory_items"
                  :fields="exit_factors_inventory_fields"
                  striped
                  border
                  sorter
                  :checkbox="true"
                  checkbox_key="recId"
                  :checkbox_ids.sync="factor_checkbox_items_exit"

                  height="300px"
                  column-filter
                  :items-per-page="200"
                  hover
                  pagination
              >

                <template #row_id="{item,index}">
                  <td>
                    <p>{{ index + 1 }}</p>

                  </td>
                </template>
<!--                <template #select="{item}">-->
<!--                  <td>-->
<!--                    <input type="checkbox" ref="permissions[]" v-model="factor_checkbox_items_exit"-->
<!--                           :value="item.recId"/>-->
<!--                  </td>-->
<!--                </template>-->
                <template #status="{item}">
                  <td>
                    <p v-if="item.statusTitle!=null">{{ item.statusTitle }}</p>

                  </td>

                </template>
                <template #partyName="{item}">

                  <td>
                    <p>{{ item.partyName }}</p>

                  </td>

                </template>
                <template #masterCode="{item}">

                  <td class="text-center">
                    <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                      {{ item.masterCode }}
                    </a>
                  </td>

                </template>
              </CDataTableFixed>



    <CModal
        :show.sync="change_factor_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          {{ $t('sureToConfirm') }}
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_factor_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_factor_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

export default {
  name: 'Login',
  components: {

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      start_date: '',
      end_date: '',
      change_factor_status_modal: false,

      factor_checkbox_items_exit: [],

      exit_factor_inventory_items: [],
      exit_factors_inventory_fields: [
        // {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        {key: 'row_id', label: this.$t('tables.number'), _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:2%'},

        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'partyName', label: this.$t('customer'), _style: 'width:10%'},
        {key: 'placeName', label: this.$t('inventory'), _style: 'width:10%'},

      ],

      status_form: 0,
    }
  },
  mounted() {

    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();


  },
  watch: {



  },
  methods: {
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.recId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});

    },
    print_data() {
      // Pass the element id here
      this.print_with_header('printMe_warehouse_output', 'printMe_warehouse_output_header'
          , 'printMe_warehouse_output_footer');
    },


    change_factor_status_data(index) {

      if (this.factor_checkbox_items_exit.length == 0) {
        return false;

      }
      this.change_factor_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('ProductId', -1);
      formData.append('Ids[]', this.factor_checkbox_items_exit[index]);


      formData.append('FacStatus', 2);

      axios.post('AddFactorPlatform', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (index < self.factor_checkbox_items_exit.length - 1) {
            self.change_factor_status_data(index + 1);
          } else {
            self.factor_checkbox_items_exit = []
            self.get_insite_lists();
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },


    get_all_data() {
      this.get_insite_lists()
    },

    get_insite_lists() {
      var self = this;

      const formData = new FormData();
      self.exit_factor_inventory_items = []

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('DeliveryType', 22);

      self.factor_checkbox_items_exit = []

      axios.post('GetDocsForCollection', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_factor_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
